'use client';
import { 
    ShieldCheckIcon, 
    ClockIcon, 
    GlobeAltIcon, 
    ChartBarIcon 
} from '@heroicons/react/24/outline';

const features = [
    {
        title: 'Global Network',
        description: 'Connected to major ports and airports worldwide, ensuring seamless international shipping.',
        icon: GlobeAltIcon,
    },
    {
        title: 'Real-time Tracking',
        description: 'Track your shipments 24/7 with our advanced tracking system and get instant updates.',
        icon: ClockIcon,
    },
    {
        title: 'Secure Handling',
        description: 'Your cargo is handled with utmost care and security throughout the journey.',
        icon: ShieldCheckIcon,
    },
    {
        title: 'Data Analytics',
        description: 'Advanced analytics to optimize routes and reduce shipping costs.',
        icon: ChartBarIcon,
    },
];

const Features = () => {
    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                        Our Mission
                    </h2>
                    <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                        We have set out to become the leading provider of drayage and destination management solutions in the USA 
                        by creating a technology-enabled, ultra-flexible carrier model that meets our customers varying needs 
                        technology-enabled, ultra-flexible carrier model that meets our customers varying needs 
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="text-center p-6 rounded-lg hover:bg-gray-50 transition duration-300"
                        >
                            <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-[#29abe2] bg-opacity-10 mb-6">
                                <feature.icon className="h-8 w-8 text-[#29abe2]" />
                            </div>
                            <h3 className="text-xl font-semibold text-gray-900 mb-3">
                                {feature.title}
                            </h3>
                            <p className="text-gray-600">
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>

                {/* <div className="mt-16 bg-[#29abe2] bg-opacity-5 rounded-2xl p-8 lg:p-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        <div className="text-center">
                            <div className="text-4xl font-bold text-[#29abe2] mb-2">98%</div>
                            <div className="text-gray-700">On-Time Delivery</div>
                        </div>
                        <div className="text-center">
                            <div className="text-4xl font-bold text-[#29abe2] mb-2">150+</div>
                            <div className="text-gray-700">Global Partners</div>
                        </div>
                        <div className="text-center">
                            <div className="text-4xl font-bold text-[#29abe2] mb-2">50K+</div>
                            <div className="text-gray-700">Happy Customers</div>
                        </div>
                        <div className="text-center">
                            <div className="text-4xl font-bold text-[#29abe2] mb-2">24/7</div>
                            <div className="text-gray-700">Customer Support</div>
                        </div>
                    </div>
                </div> */}
            </div>
        </section>
    );
};

export default Features; 